/**
 * Parse a latitude/longitude pair out of free-form input: a plain
 * "lat, lng" string, or a pasted Google Maps URL in any of its common
 * formats (@lat,lng,zoom / ?q=lat,lng / ll=lat,lng / !3dlat!4dlng).
 * Returns { lat, lng } as numbers, or null if nothing valid was found.
 */
export const parseLatLng = (input) => {
  if (!input || typeof input !== "string") return null;
  const text = input.trim();

  const patterns = [
    /@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/, // .../@lat,lng,zoomz
    /[?&](?:q|ll)=(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/, // ?q=lat,lng or &ll=lat,lng
    /!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/, // ...!3dlat!4dlng...
    /^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)$/, // plain "lat, lng"
  ];

  for (const pattern of patterns) {
    const match = text.match(pattern);
    if (match) {
      const lat = parseFloat(match[1]);
      const lng = parseFloat(match[2]);
      if (isValidLatLng(lat, lng)) return { lat, lng };
    }
  }
  return null;
};

export const isValidLatLng = (lat, lng) =>
  Number.isFinite(lat) && Number.isFinite(lng) &&
  lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
